import { flow } from 'mobx-state-tree';

import { getStores } from '../..';
import { getFavouritesRequestOptions } from './add-favourite';

export const removeFavourite = flow(function* (self, poi) {
  const { config } = getStores(self, 'config');

  if (config.gysService.useMock) return;
  if (self.list.filter((x) => x.id === poi.id)?.length === 0) return;
  try {
    var removeIndex = self.list.map((x) => x.id).indexOf(poi.id);
    self.list.splice(removeIndex, 1);
    yield fetch(
      `${config.gysService.url}/get-your-spot/favorites`,
      getFavouritesRequestOptions(self, config),
    );
  } catch (error) {
    console.error(error);
  }
});
